import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Швець Павло',
  role: 'Голова комісії з аматорського альпінізму',
  email: 'kamtugezza@gmail.com'
}, {
  name: 'Веретюшкін Василь',
  role: 'Член комісії з аматорського альпінізму',
  email: 'basylvv@gmail.com'
}];
export function AmateurAlpinismCommission() {
  return <FederationMembersPage title="Комісія з аматорського альпінізму" subtitle="Комісія з аматорського альпінізму ФАіСУ" members={members} data-id="element-423" />;
}